import React, { useState, useEffect, useRef } from 'react';
import { PREVIEW_ERROR_KEY, errorsMap } from '../../constants';
import cn from 'classnames';
import styles from './Preview.module.scss';

const setUrl = (url) => {
  if (!url) return;

  return `${url.split('/').slice(0, -1).join('/')}/preview.mp4`;
};

const Preview = ({ previewUrl, setError, className, error }) => {
  const videoRef = useRef();

  const [shouldBeUpdated, setShouldBeUpdated] = useState(true);

  const handleError = () => {
    if (!error) {
      setError(errorsMap.get(PREVIEW_ERROR_KEY));
    }
  };

  const handleLoadedData = () => {
    if (error === errorsMap.get(PREVIEW_ERROR_KEY)) {
      setError('');
    }
  };

  useEffect(() => {
    if (!shouldBeUpdated) {
      setShouldBeUpdated(true);
    }
  }, [previewUrl]);

  useEffect(() => {
    let timeoutId = null;

    if (shouldBeUpdated) {
      videoRef.current.src = setUrl(previewUrl);

      setShouldBeUpdated(false);
    } else {
      timeoutId = setTimeout(() => {
        setShouldBeUpdated(true);
      }, 60000);
    }    

    return () => clearTimeout(timeoutId);
  }, [shouldBeUpdated]);

  return (
    <video
      ref={videoRef}
      onError={handleError}
      onLoadedData={handleLoadedData}
      className={cn(styles.root, className)}
      autoPlay={true}
      crossOrigin="anonymous"
    />
  );
};

export default Preview;
